import { isRequired } from '../../../utils/validation';

export const initialValues = {
  type: '',
  file: ''
};

export const fieldsProps = {
  type: {
    label: 'Pilih Tipe Update Stok Pangkalan',
    name: 'type',
    withAsterisk: true,
  },
  propsfile: {
    title: 'File Update Stok',
    name: 'file',
    maxSize: 20000000,
    info: 'Maksimal ukuran file 20 Mb dan format .csv',
    require: true
  }
};

export const validate = (values = initialValues) => {
  const { type, file } = values;
  const rules = {
    type: isRequired(type, 'tipe harus dipilih'),
    file: isRequired(file, 'File harus diisi')
  };

  return rules;
};
